import React from 'react';
import { Trash2 } from 'lucide-react';

/**
 * Fixed bottom Approve/Reject bar + top Delete button. Confirmation dialog
 * lives in the parent (window.confirm — same behavior as before).
 */
export default function ReceiptActions({ saving, onStatus, onDelete, colors }) {
  return (
    <>
      {/* Delete */}
      <button
        data-testid="detail-delete-btn"
        onClick={onDelete}
        className="flex items-center justify-center gap-2 w-full py-3 text-sm font-semibold transition-opacity hover:opacity-70"
        style={{ color: colors.error }}
      >
        <Trash2 size={16} />
        Delete receipt
      </button>

      {/* Action bar */}
      <div
        className="fixed bottom-0 left-0 lg:left-64 right-0 flex items-center gap-3 px-4 sm:px-6 py-4 border-t z-30"
        style={{ backgroundColor: colors.bg, borderColor: colors.border }}
      >
        <div className="max-w-3xl mx-auto w-full flex gap-3">
          <button
            data-testid="reject-btn"
            onClick={() => onStatus('rejected')}
            disabled={saving}
            className="flex-1 h-12 rounded-full border flex items-center justify-center text-sm font-semibold transition-colors hover:opacity-80 disabled:opacity-50"
            style={{ borderColor: colors.border, backgroundColor: colors.surface, color: colors.textMuted }}
          >
            Reject
          </button>
          <button
            data-testid="approve-btn"
            onClick={() => onStatus('approved')}
            disabled={saving}
            className="flex-[2] h-12 rounded-full flex items-center justify-center text-sm font-bold text-white transition-colors hover:opacity-80 disabled:opacity-50"
            style={{ backgroundColor: colors.accent }}
          >
            Approve
          </button>
        </div>
      </div>
    </>
  );
}
